var map = {
	"./0.svg": 8847,
	"./1.svg": 58233,
	"./2.svg": 69083,
	"./3.svg": 92079,
	"./4.svg": 86613,
	"./5.svg": 35830,
	"./6.svg": 15939,
	"./7.svg": 51448,
	"./8.svg": 17799,
	"./9.svg": 58561,
	"./slot.svg": 70915
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43103;